import {Component} from '@angular/core';
import {ClientEditDialog} from '@app/shared/edit-dialog/client/client-edit-dialog.component';
import { ModalFilter } from '@app/shared/model-table/model-table-filter';
import {WebClient} from '@injectables';
import {Client} from '@models';

@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	styleUrls: ['./clients.component.scss']
})
export class ClientsComponent {

	constructor(
		private readonly webClient: WebClient,
	) { }
	public searchText: string = '';
	public selected: string = 'Name';
	public readonly model = Client;
	public readonly restClient = this.webClient.model.client;
	public readonly editDialog = ClientEditDialog;
	public readonly deletable = (v: Client) => v.name !== 'Strayos';

	public filterConfigs: ModalFilter[] = [
		{
			type: 'input-string',
			column: 'Name',
			dbColumn: 'name',
		}]
}

